<template>
  <div class="box9">
    <div class="block" ref="block"></div>
    <pageTitle title="采用必修+拓展模式授课<br />高效就业、灵活提升" />

    <div class="title-top"><span>必修课</span> — 打造实力派数据工程师</div>

    <div class="content">
      <div
        class="subject-box"
        v-for="(item, index) in list"
        :key="index"
        ref="item"
      >
        <div class="subject" @click="changeCur(index)">
          <div class="stage">{{ item.stage }}</div>
          <div class="title">{{ item.tit }}</div>
          <div
            class="icon"
            :class="{ 'img-rotate': cur == index && showAnswer }"
          >
            <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
          </div>
        </div>

        <div
          class="course-content"
          :class="{ 'show-answer': cur == index && showAnswer }"
        >
          <div class="line"></div>
          <!-- <div v-if="item.target.length !== 0">
            <div class="title-icon">
              <img
                class="icon1"
                src="../../../assets/coursePage/pythonData/box9/icon1.png"
                alt
              />主讲内容
            </div>

            <div class="targe">
              <p v-for="j in item.target" :key="j + 'a'">{{ j }}</p>
            </div>
          </div> -->

          <div v-if="item.content !== ''">
            <div class="title-icon">
              <img
                class="icon3"
                src="../../../assets/coursePage/pythonData/box9/icon1.png"
                alt
              />主讲内容
            </div>

            <div class="targe2">
              <p>{{ item.content }}</p>
            </div>
          </div>

          <div v-if="item.scheme.length !== 0">
            <div class="title-icon">
              <img
                class="icon2"
                src="../../../assets/coursePage/pythonData/box9/icon3.png"
                alt
              />可掌握核心能力
            </div>

            <div class="targe">
              <p v-for="i in item.scheme" :key="i + 'b'">{{ i }}</p>
            </div>
          </div>

          <div v-if="item.point.length !== 0">
            <div class="title-icon">
              <img
                class="icon4"
                src="../../../assets/coursePage/pythonData/box9/icon4.png"
                alt
              />可解决的现实问题
            </div>

            <div class="targe">
              <p>{{ item.point }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          stage: "阶段一",
          tit: "数据分析基础",
          target: [],
          content: "Linux操作系统、MySQL与SQL、Kettle与BI工具、电商运营指标分析",
          scheme: [
            "1.掌握MySQL数据库的使用；",
            "2.掌握SQL语法；",
            "3.掌握Kettle数据迁移工具的使用；",
            "4.熟练使用BI可视化工具；",
            "5.对数据开发有一定认知，掌握BI工程师所具备的基本技能。",
          ],
          point: "熟练掌握MySQL/SQL、Kettle以及BI工具使用，能够解决传统数仓业务开发任务。",
        },
        {
          stage: "阶段二",
          tit: "Hadoop技术栈",
          target: [],
          scheme: [
            "1.掌握Linux常用命令，为数据开发后续学习打下的良好基础；",
            "2.掌握大数据的核心框架Hadoop以及其生态体系，完成HDFS、MapReduce及Yarn机制基本理解与使用；能够搭建Hadoop高可用HA集群；",
            "3.掌握Hive的使用和调优；",
            "4.具备Hadoop开发能力、离线数据仓库开发能力；",
            "5.能够完成基本构建企业级数仓。"
          ],
          content: "大数据开发Hadoop基础、 Hive基础、Hive进阶",
          point: "熟悉Linux操作系统，以及各种Linux命令，能够解决企业级大数据集群搭建问题，为进阶大数据开发奠定基础。",
        },
        {
          stage: "阶段三",
          tit: "千亿级离线数仓项目",
          target: [],
          scheme: [
            "1.掌握泛电商行业离线数仓的分层与建模，从需求、设计、研发、测试到落地上线的完整项目流程；",
            "2.行业内首个深度讲解数仓建模模型方案的主体项目；",
            "3.包括海量数据场景下如何优化配置；",
            "4.掌握项目迁移能力，能够将项目迁移至泛电商的各个领域；",
            "5.掌握在泛电商行业中关于全量与增量数据处理模式；",
            "6.提供泛电商行业下的数据存储分析以及服务监控方案。"
          ],
          content:
            "大数据部署运维：Cloudera Manager、分析决策需求：数据仓库、数据采集：DataX、数据分析：Hive、数据调度：Dolphinscheduler、OLAP系统存储：PostgreSql、Fine Report数据报表与大屏、数仓建模: 范式与维度建模、五大核心主题域开发（销售域、供应链域、会员域等）",
          point: "能够解决企业级常见数据仓库搭建，从项目的需求、技术架构、业务架构、部署平台、ETL设计、作业调度等整套pipeline，完成大数据体系下的企业级数据仓库构建。"
        },
        {
          stage: "阶段四",
          tit: "Python编程",
          target: [],
          scheme: [
            "1.掌握Python开发环境基本配置；",
            "2.掌握运算符、表达式、流程控制语句、数组等的使用；",
            "3.掌握字符串的基本操作；",
            "4.初步建立面向对象的编程思维；",
            "5.熟悉异常捕获的基本流程及使用方式；",
            "6.掌握类和对象的基本使用方式；",
            "7.知道多进程多线程的原理。",
          ],
          content: "Python基础语法、Python面向对象、Python高级语法、 Python多任务编程、Python网络编程",
          point: "熟练掌握Python语言，建立编程思维，使学员能够熟练使用Python技术完成程序编写。熟练使用Python面向对象程序设计思想，掌握数据开发必备Python高级语法，解决常见Python开发问题。",
        },
        {
          stage: "阶段五",
          tit: "Spark技术栈",
          target: [],
          scheme: [
            "1.掌握Spark的RDD、DAG、CheckPoint等设计思想；",
            "2.掌握SparkSQL结构化数据处理，Spark On Hive；",
            "3.掌握Structured Streaming整合多数据源完成实时数据处理；",
            "4.具备Spark全栈开发能力，满足大数据行业多场景统一技术栈的数据开发，提供就业核心竞争力。"
          ],
          content:
            "SparkSQL整合ES自定义数据源、DS任务界面化调度、用户画像标签构建规则、用户画像规则类标签构建、用户画像统计类标签构建",
          point: "掌握全球热门的Spark技术栈，通过SparkCore和SparkSQL解决数据处理与统计分析工作，进阶高级大数据开发工程师。",
        },
        {
          stage: "阶段六",
          tit: "用户画像与推荐系统",
          target: [],
          scheme: [
            "1.掌握SparkSQL整合ES自定义数据源；", 
            "2.掌握用户画像构建流程；", 
            "3.掌握用户画像标签构建规则；", 
            "4.掌握用户画像规则类标签构建；",
            "5.掌握用户画像统计类标签构建。"
          ],
          content: "SparkSQL整合ES自定义数据源、DS任务界面化调度、用户画像标签构建规则、用户画像规则类标签构建、用户画像统计类标签构建",
          point: "项目提供了全行业用户画像解决方案, 使用SparkSQL+ES+DS构建企业级用户画像，通过SparkSQL+MySQL构建通用行业用户画像标签体系。",
        },
        {
          stage: "阶段七",
          tit: "AI+出行数据分析",
          target: [],
          scheme: ["能够利用AI大模型相关技术，构建AlAgent的数据开发相关应用，助力高效数据开发。"],
          content:
            "基于Agent的数据库查询操作、大模型Function call原理与实现、Assistant APl的原理及应用、基于本地知识库搭建答疑聊天机器人",
          point: "掌握如何使用AI大模型帮助数据开发和数据分析编程效率提升，具备使用AI大模型解决问题的能力。",
        },
      ],
      cur: -1,
      showAnswer: true,
      prevItemHeight: 0,
    };
  },
  methods: {
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
        this.cur = index;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
      this.goTop(index);
    },
  },
};
</script>

<style lang="less" scoped>
.box9 {
  padding: 0px 0px;
  padding-bottom: 60px;
  width: 100%;
  background: #e5f7ff;
  .block {
    height: 80px;
  }
  .title-top {
    position: relative;
    margin: 60px auto 0;
    margin-bottom: 40px;
    padding-left: 50px;
    width: 690px;
    height: 100px;
    background: url("../../../assets/coursePage/pythonData/box9/title.png")
      no-repeat;
    background-size: cover;
    border-radius: 20px;
    box-shadow: 0px 6px 29px 0px rgba(135, 212, 240, 0.98);
    box-sizing: border-box;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    font-weight: normal;
    line-height: 100px;
    letter-spacing: 0px;
    color: #ffffff;

    span {
      font-family: PingFangSC-Semibold;
      font-size: 32px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 100px;
      letter-spacing: 0px;
      color: #ffffff;
    }
    &::after {
      position: absolute;
      right: 0px;
      bottom: 0px;
      content: "";
      width: 180px;
      height: 126px;
      background: url("../../../assets/coursePage/pythonData/box9/icon.png")
        no-repeat;
      background-size: cover;
    }
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    overflow: hidden;
    background: #ffffff;
    border-radius: 16px;
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 24px 32px;
    width: 100%;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;
    .stage {
      font-family: PingFangSC-Semibold;
      font-size: 28px;
      font-weight: bold;
      line-height: 96px;
      letter-spacing: 0px;
      white-space: nowrap;
      color: #3dafff;
    }

    .title {
      margin-left: 24px;
      margin-right: 20px;
      font-family: PingFangSC-Medium;
      font-size: 28px;
      font-weight: bold;
      font-stretch: normal;

      letter-spacing: 0px;
      color: #24375c;
      width: 496px;
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    max-height: 0;
    opacity: 0;
    padding: 0 40px;
    transition: 0.3s ease all;

    overflow: hidden;
    z-index: 3;

    .line {
      margin: 0 auto;
      margin-bottom: 32px;
      width: 622px;
      height: 1px;
      margin-left: -8px;
      background: #f2f3f5;
    }
  }

  .show-answer {
    padding: 0px 40px;
    // padding-bottom: 40px;
    // display: block;
    max-height: 2500px;
    opacity: 1;
    transition: 0.4s ease all;
    border-radius: 16px;
  }

  .title-icon {
    display: flex;
    align-items: center;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1d2129;
    line-height: 44px;
    margin-bottom: 16px;

    img {
      margin-right: 12px;
      width: 32px;
      height: 32px;
    }
  }

  .main-content {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    .block {
      margin-bottom: 16px;
      margin-right: 16px;
      padding: 0px 16px;
      height: 44px;
      background: rgba(179, 227, 254, 0.32);
      border-radius: 8px;

      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }
  }

  .targe {
    margin-bottom: 48px;
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
    margin-left: 44px;
    p {
      position: relative;
      // &::before {
      //   content: "";
      //   display: block;
      //   width: 4px;
      //   height: 4px;
      //   background: #86909c;
      //   position: absolute;
      //   left: -22px;
      //   top: 18px;
      //   border-radius: 50%;
      // }
    }
  }
  .targe2 {
    margin-bottom: 48px;
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
    margin-left: 44px;
  }
}
</style>
